import { httpsCallable } from 'firebase/functions'

import { functions } from '@/firebase'
const createCompletion = httpsCallable(functions, 'createChatCompletion')

const generateTermSuggestions = async (flaggedTerm, language) => {
  const prompt = `
We've flagged an error in our system for this phrase: "${flaggedTerm}" for our speech recognition system in ${language}.

Instructions:
- Do NOT wrap the output in markdown or code blocks (no \`\`\`json).
- ONLY return a raw JSON object.
- If it's a single letter, suggest three short, natural words or phrases that contain the letter(s).
- If it's a standalone word, suggest three short, natural phrases that provide context.
- The explanation field should briefly describe why the term was flagged.
Return output strictly in this format:
{
  "explanation": "Brief explanation of the issue.",
  "options": [
    "First suggestion",
    "Second suggestion",
    "Third suggestion"
  ]
}
`

  const ai_data = {
    chat: {
      model: 'gpt-4o',
      temperature: 1.2,
      messages: [
        {
          role: 'user',
          content: prompt,
        },
      ],
    },
    response_format: {
      type: 'json_object',
    },
  }

  try {
    const { data } = await createCompletion(ai_data)

    return data?.response?.content
  } catch (error) {
    console.error('Error generating term suggestions:', error)

    return {
      error: true,
      message: error?.message || 'Error generating term suggestions',
    }
  }
}

export default generateTermSuggestions
